<template>
  <div class="row" id="table-bordered">
    <div class="col-12">
      <div class="card col-8">
        <div class="card-header mb-1">
          <h4 class="card-title">Test topshirish yo'nalishlari</h4>
          <button class="btn btn-primary waves-effect waves-light"
                  @click="addSubject">
            Yangi qo'shish
          </button>
        </div>
        <div class="card-content">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th>#</th>
                <th>Nomlanishi</th>
                <th class="text-center">Funksiyalar</th>
              </tr>
              </thead>
              <transition name="fade" :duration="2000">
                <tbody v-if="loaded">
                <tr v-for="(spec, index) in specList" :class="spec.id === selectedSpecId ? 'selected_one' : ''">
                  <th scope="row">{{ index + 1 }}</th>
                  <td @click="selectSpec(spec.id, spec.name)" style="cursor: pointer">{{ spec.name }}</td>
                  <td class="text-center">
                    <button class="btn btn-icon rounded-circle btn-flat-primary waves-effect waves-light"
                            title="Ko'rish"
                            @click="viewSubject(spec.id)">
                      <i style="font-size: 1.5rem" class="feather icon-eye"/>
                    </button>
                    <button class="btn btn-icon rounded-circle btn-flat-info waves-effect waves-light"
                            title="Tahrirlash"
                            @click="editSubject(spec)">
                      <i style="font-size: 1.5rem" class="feather icon-edit"/>
                    </button>
                    <button class="btn btn-icon rounded-circle btn-flat-danger waves-effect waves-light"
                            title="O'chirish"
                            @click="deleteSubject(spec.id)">
                      <i style="font-size: 1.5rem" class="feather icon-trash-2"/>
                    </button>
                  </td>
                </tr>
                </tbody>
              </transition>
            </table>
          </div>

          <div class="d-flex justify-content-center mt-1" v-if="specList && specList.length > 10">
            <v-pagination
                v-model="currentPage"
                :classes="bootstrapPaginationClasses"
                :page-count="totalSize"
            />
          </div>
        </div>
      </div>
      <div class="card col">
        <div class="card-header mb-1">
          <h4 class="card-title">Yo'nalish imtihonlari</h4>
          <h4 class="card-title">Tanlangan yo'nalish: <strong>{{ selectedSpecName }}</strong></h4>
          <button class="btn btn-primary waves-effect waves-light" @click="addExams">
            Yangi qo'shish
          </button>
        </div>
        <div class="card-content">
          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
              <tr>
                <th>#</th>
                <th>Fan</th>
                <th>Fan statusi</th>
                <th class="text-center">Savol bali</th>
                <th class="text-center">Savollar soni</th>
                <th class="text-center">Funksiyalar</th>
                <th/>
              </tr>
              </thead>
              <transition name="fade" :duration="2000">
                <tbody v-if="loaded">
                <tr v-for="(subject, index) in abitExamList">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ subject.subjectName }}</td>
                  <td>{{ subject.statusName }}</td>
                  <td class="text-center">{{ subject.quesBall }}</td>
                  <td class="text-center">{{ subject.quesCount }}</td>
                  <td class="text-center">
                    <button class="btn btn-icon rounded-circle btn-flat-info waves-effect waves-light"
                            title="Tahrirlash"
                            @click="editExam(subject)">
                      <i style="font-size: 1.5rem" class="feather icon-edit"/>
                    </button>
                    <button class="btn btn-icon rounded-circle btn-flat-danger waves-effect waves-light"
                            title="O'chirish"
                            @click="deleteExam(subject.id)">
                      <i style="font-size: 1.5rem" class="feather icon-trash-2"/>
                    </button>
                  </td>
                </tr>
                </tbody>
              </transition>
            </table>
          </div>

          <div class="d-flex justify-content-center mt-1" v-if="specList && specList.length > 10">
            <v-pagination
                v-model="currentPage"
                :classes="bootstrapPaginationClasses"
                :page-count="totalSize"
            />
          </div>
        </div>
      </div>
    </div>

    <modal :modal="showExamModal || showModal" @modal-closed="closeModals" :modal-size="`modal-lg`">
      <ExamsForm v-if="showExamModal && deleteApi === ''"
                 :subject="exam"
                 :spec-list="specList"
                 :subjects="subjectList"
                 :subject-statuses="subjectStatuses"
                 @saved="getSpecs()"/>
      <SubjectForm v-if="showModal && deleteApi === ''"
                   :subject="subject"
                   @saved="getSpecs(currentPage - 1)"/>
      <deleting-modal v-if="(showExamModal || showModal) && deleteApi !== ''"
                      :delete-api="deleteApi"
                      @deleted="getSpecs()"/>
    </modal>

  </div>
</template>

<script>
import SubjectForm from "./SpecForm";
import ExamsForm from "./ExamsForm";
import vPagination from 'vue-plain-pagination'
import Modal from "../../components/Modal";
import DeletingModal from "../../components/DeletingModal";

export default {
  name: "Subjects",
  components: {
    DeletingModal,
    Modal,
    SubjectForm,
    ExamsForm,
    vPagination
  },
  data() {
    return {
      specList: [],
      subject: {},
      exam: {},
      loaded: false,
      showModal: false,
      showExamModal: false,
      something: false,
      deleteApi: '',
      totalSize: 1,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      abitExamList: [],
      subjectList: [],
      subjectStatusList: [],
      subjectStatuses: [],
      selectedSpecName: '',
      selectedSpecId: null,
    }
  },

  methods: {
    selectSpec(specId, specName) {
      this.selectedSpecName = specName;
      this.selectedSpecId = specId;
      this.getAbitExams(specId);
    },
    getSpecs(skip = 0) {
      this.loaded = false;
      this.$api.get(`admin/Reference/GetAbitSpecList?skip=${skip}&take=30`)
          .then(res => {
            if (!res.error) {
              this.specList = res.result.data;
              this.totalSize = Math.ceil(res.result.total / 10);
              this.selectedSpecName = this.selectedSpecName ? this.selectedSpecName : this.specList[0].name;
              this.selectedSpecId = this.selectedSpecId ? this.selectedSpecId : this.specList[0].id
              this.getAbitExams(this.selectedSpecId);
            }
          })
          .catch(err => {
            //
          })
          .finally(() => {
            this.loaded = true
          })
    },
    getSubjects() {
      this.loaded = false;
      this.$api.get(`main/Home/Test/SubjectList`)
          .then(res => {
            if (!res.error) {
              this.subjectList = res.result;
            }
          })
          .catch(err => {

          })
          .finally(() => {
            this.loaded = true
          })
    },
    getSubjectStatuses() {
      this.loaded = false;
      this.$api.get(`admin/AbitExam/SubjectStatusList`)
          .then(res => {
            if (!res.error) {
              this.subjectStatuses = res.result;
            }
          })
          .catch(err => {

          })
          .finally(() => {
            this.loaded = true
          })
    },
    getAbitExams(specId = 1) {
      this.loaded = false;
      this.$api.get(`admin/abitExam/getAbitExamList?specId=${specId}&skip=0&take=10`)
          .then(res => {
            if (!res.error) {
              this.abitExamList = res.result.data;
            }
          })
          .catch(err => {

          })
          .finally(() => {
            this.loaded = true
          })
    },
    viewSubject(id) {
      //this.$router.push({name: 'subject-view', params: {id: id}});
    },

    addSubject() {
      this.subject = this.createSubjectObject();
      this.showModal = true;
      this.deleteApi = '';
    },
    editSubject(subject) {
      this.subject = this.createSubjectObject(subject);
      this.showModal = true;
      this.deleteApi = '';
    },
    deleteSubject(id) {
      this.showModal = true;
      this.deleteApi = `Admin/Reference/DeleteAbitSpec/${id}`;
    },
    createSubjectObject(subject = null) {
      if (subject)
        return {
          id: subject.id,
          name: subject.name,
          displayOrder: subject.displayOrder
        };
      else
        return {
          id: 0,
          name: '',
          displayOrder: ''
        };

    },
    addExams() {
      console.log(' imcl;icked')
      this.exam = this.createExamObject();
      this.showExamModal = true;
      this.deleteApi = '';
    },
    editExam(exam) {
      this.exam = this.createExamObject(exam);
      this.showExamModal = true;
      this.deleteApi = '';
    },
    deleteExam(id) {
      this.showExamModal = true;
      this.deleteApi = `Admin/AbitExam/DeleteAbitExam/${id}`;
    },
    createExamObject(exam = null) {
      if (exam)
        return {
          id: exam.id,
          specId: exam.specId,
          subjectId: exam.subjectId,
          subjectStatusId: exam.subjectStatusId,
          quesCount: exam.quesCount,
          quesBall: exam.quesBall,
          displayOrder: exam.displayOrder,
          testMinute: exam.testMinute,
        };
      else
        return {
          id: 0,
          specId: this.selectedSpecId,
          subjectId: null,
          subjectStatusId: null,
          quesCount: null,
          quesBall: null,
          displayOrder: null,
          testMinute: null
        };
    },
    closeModals() {
      this.showModal = false;
      this.showExamModal = false;
    }
  },
  watch: {
    currentPage() {
      this.getSpecs(this.currentPage - 1);
    }
  },
  created() {
    this.getSpecs();
    this.getSubjects();
    this.getSubjectStatuses();
  }
}
</script>

<style scoped>
.selected_one {
  color: white;
  background-color: #7367F0;
}

.table-hover tbody tr:hover {
  color: white;
  background-color: #7367F0;
}
</style>
